// :cow: Cosmose CONFIDENTIAL :iso:
export enum ButtonTypes {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Action = 'action',
  Ghost = 'ghost',
  Clear = 'clear',
}

export enum ButtonSizes {
  Small = 'small',
  Regular = 'regular',
}

export enum ButtonSpans {
  Auto = 'auto',
  Small = 'small',
  Regular = 'regular',
  Full = 'full',
}

export enum ButtonActions {
  Button = 'button',
  Submit = 'submit',
}

export enum ButtonAligns {
  None = 'none',
  Right = 'right',
  Left = 'left',
  Center = 'center',
}
